import React from "react";
import {Spin} from "antd";

export default () => {
  return <div
    style={{height: 500, width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <Spin size={"large"}/>
  </div>
}
